"use strict";
exports.ROW_STYLE = "\n.select-column {\n    text-align: center;\n}\n\n.row-expand-button {\n    cursor: pointer;\n    text-align: center;\n}\n\n.clickable {\n    cursor: pointer;\n}\n";
//# sourceMappingURL=/components/row.style.js.map


//////////////////
// WEBPACK FOOTER
// D:/xampp_bk/htdocs/xampp/organicshop/~/angular-4-data-table/dist/components/row.style.js
// module id = ../../../../angular-4-data-table/dist/components/row.style.js
// module chunks = 3